
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../../environments/environment';
import { AppProperties } from '../model/application-properties';
import { OktaConfig, OktaSettings } from '../model/okta-settings';
import { ApiLoadService } from './api-load-service';
import { AppSettingsService } from './app-settings.service';
import { environment } from 'src/environments/environment.prod';

/**
 * Domain specific URL from ApiLoadService class is subscribed inside  getSettings()
 * method to set API in  environment.ts file
 */
@Injectable()
export class AppLoadService {
  property: AppProperties = new AppProperties();
  appProperties: AppProperties;
  constructor(private httpClient: HttpClient,
    private apiservice: ApiLoadService, private appSettingsService: AppSettingsService) { }

  // setting backend api inside environment.ts file in below method


  getSettings(): Promise<any> {
    if (window.location.hostname !== 'localhost') {
      return this.apiservice.getBackendApi().toPromise().then(
        res => {
          env.uploadFileSize = res.uploadFileSize;
          env.edmUploadFileSize= res.edmUploadFileSize;
          env.logLevel = res.logLevel;
          env.production = res.production;
          env.localEnviornment = res.localEnviornment;
          env.fclURL = res.fclURL;
          env.fclClientId = res.fclClientId;
          env.fclSecret = res.fclSecret;
          env.fclGrantType = res.fclGrantType;
          env.fclScope = res.fclScope;
          env.oktaURL = res.oktaURL;
          env.oktaIssuer = res.oktaIssuer;
          env.oktaTempIssuer = res.oktaTempIssuer;
          env.oktaTempClientId = res.oktaTempClientId;
          env.oktaClientId = res.oktaClientId;
          env.oktaScopes = res.oktaScopes;
          env.apiAddressValidationURL = res.apiAddressValidationURL;
          env.apiGatewayURL = res.apiGatewayURL;
          env.apiGatewayClientId = res.apiGatewayClientId;
          env.apiGatewaySecret = res.apiGatewaySecret;
          env.apiGatewayGrantType = res.apiGatewayGrantType;
          env.apiGatewayScope = res.apiGatewayScope;
          env.apiUserURL = res.apiUserURL;
          env.apiItemURL = res.apiItemURL;
          env.apiOpsItemURL = res.apiOpsItemURL;
          env.apiASNURL = res.apiASNURL;
          env.apiGetASNURL = res.apiGetASNURL;
          env.apiLookupURL = res.apiLookupURL;
          env.apiCriteriaSvc = res.apiCriteriaSvc;
          env.apiPrinterUrl = res.apiPrinterUrl;
          env.apiLookupNameValueURL = res.apiLookupNameValueURL;
          env.apiCycleCountDefinitionURL = res.apiCycleCountDefinitionURL;
          env.apiCCApproveRejectURL = res.apiCCApproveRejectURL;
          env.apiWaveTaskConfigURL = res.apiWaveTaskConfigURL;
          env.apiWaveURL = res.apiWaveURL;
          env.apiWaveDetailsURL = res.apiWaveDetailsURL;
          env.apiOrderURL = res.apiOrderURL;
          env.apiBulkURL = res.apiBulkURL;
          env.apiCartURL = res.apiCartURL;
          env.apiTaskGroupURL = res.apiTaskGroupURL;
          env.apiValidateItem = res.apiValidateItem;
          env.apiFacilityURL = res.apiFacilityURL;
          env.apiLookupURL = res.apiLookupURL;
          env.apiZoneGroupURL = res.apiZoneGroupURL;
          env.apiTaskURL = res.apiTaskURL;
          env.apiCustomerURL = res.apiCustomerURL;
          env.apiVendorURL = res.apiVendorURL;
          env.apiLocationURL = res.apiLocationURL;
          env.apiLocationSlottingUrl = res.apiLocationSlottingUrl;
          env.apiCycleCountURL = res.apiCycleCountURL;
          env.apiAsnVerifyUrl = res.apiAsnVerifyUrl;
          env.apiAsnReceivingUrl = res.apiAsnReceivingUrl;
          env.apiBussServAPPID = res.apiBussServAPPID;
          env.pattern = res.pattern;
          env.superAdminRoleName = res.superAdminRoleName;
          env.apiInventoryLocksURL = res.apiInventoryLocksURL;
          env.apiInventoryURL = res.apiInventoryURL;
          env.apiValueAddedServiceURL = res.apiValueAddedServiceURL;
          env.apiCartonURL = res.apiCartonURL;
          env.apiPackServiceURL = res.apiPackServiceURL;
          env.apiDocumentsURL = res.apiDocumentsURL;
          env.apiInventoryMasterURL = res.apiInventoryMasterURL;
          env.apiLTLShipmentURL = res.apiLTLShipmentURL;
          env.apiShipmentURL = res.apiShipmentURL;
          env.apiLookupsURL = res.apiLookupsURL;
          env.apiCutOffURL = res.apiCutOffURL;
          env.apiLotMasterURL = res.apiLotMasterURL;
          env.apiOrderShipmentURL = res.apiOrderShipmentURL;
          env.apiAppointmentURL = res.apiAppointmentURL;
          env.apiRlogRaRURL=res.apiRlogRaRURL;
          env.apiTaskDetailsURL = res.apiTaskDetailsURL;
          env.apiUserActivityURL = res.apiUserActivityURL;
          env.apiUserActivityTrackerURL = res.apiUserActivityTrackerURL;
          env.apiJobSchedule = res.apiJobSchedule;
          env.apiBatchDummy = res.apiBatchDummy;

          // Reports
          env.spotFileURL = res.spotFileURL;
          env.pickListReportRoute = res.pickListReportRoute;

          // Rlog
          env.apiRlogBussServAPPID = res.apiRlogBussServAPPID;
          env.apiRlogVendorURL = res.apiRlogVendorURL;
          env.apiRlogLocationCategoriesURL = res.apiRlogLocationCategoriesURL;
          env.apiRlogAsnsURL = res.apiRlogAsnsURL;
          env.apiRlogGroupMatrixURL = res.apiRlogGroupMatrixURL;
          env.apiRlogAsnItemsURL = res.apiRlogAsnItemsURL;
          env.apiRlogSourceURL = res.apiRlogSourceURL;
          env.apiRlogGroupDefsURL = res.apiRlogGroupDefsURL;
          env.apiRlogRefCodesURL = res.apiRlogRefCodesURL;
          env.apiRlogReturnTypesURL = res.apiRlogReturnTypesURL;
          env.apiRlogDepartmentsURL = res.apiRlogDepartmentsURL;
          env.apiRlogDepartmentclassesURL = res.apiRlogDepartmentclassesURL;
          env.apiRlogLocationsURL = res.apiRlogLocationsURL;
          env.apiRlogItemsURL = res.apiRlogItemsURL;
          env.apiRlogXRefsURL = res.apiRlogXRefsURL;
          env.apiRlogPreapprovedItemsURL = res.apiRlogPreapprovedItemsURL;
          env.apiRlogCategoryURL = res.apiRlogCategoryURL;
          env.apiRlogClusterSequenceURL = res.apiRlogClusterSequenceURL;
          env.apiRlogWarehousesURL = res.apiRlogWarehousesURL;
          env.apiRlogLocCapacityURL = res.apiRlogLocCapacityURL;
          env.apiRlogSalvageDealersURL = res.apiRlogSalvageDealersURL;
          env.apiRlogCloseSBNumURL = res.apiRlogCloseSBNumURL;
          env.apiRlogCarrierURL = res.apiRlogCarrierURL;
          env.apiRlogScreenConfigsURL = res.apiRlogScreenConfigsURL;
          env.apiRlogScansURL = res.apiRlogScansURL;
          env.apiRlogRewarehousemovesURL = res.apiRlogRewarehousemovesURL;
          env.apiRlogPrepSearchCriteriaURL = res.apiRlogPrepSearchCriteriaURL;
          env.apiRlogHashdefsURL = res.apiRlogHashdefsURL;
          env.apiRlogContainerTypesURL = res.apiRlogContainerTypesURL;
          env.apiRlogOutboundWarehousesURL = res.apiRlogOutboundWarehousesURL;
          env.apiRlogPutawayURL = res.apiRlogPutawayURL;
          env.apiRlogReturnPointsURL = res.apiRlogReturnPointsURL;
          env.apiRlogRewarehouseURL = res.apiRlogRewarehouseURL;
          env.apiRlogPrepShipmentURL = res.apiRlogPrepShipmentURL;
          env.apiRlogSlotbyURL = res.apiRlogSlotbyURL;
          env.apiRlogPickingURL = res.apiRlogPickingURL;
          env.apiRlogEsiURL = res.apiRlogEsiURL;
          env.apiRlogRaEntryURL = res.apiRlogRaEntryURL;
          env.apiRlogShipURL = res.apiRlogShipURL;
          env.apiRlogReprintLabelURL = res.apiRlogReprintLabelURL;
          env.apiRlogMobilityDekitActivityURL = res.apiRlogMobilityDekitActivityURL;
          env.apiRlogSlpLabelModelURL = res.apiRlogSlpLabelModelURL;
          env.apiRlogModifyShipmentURL = res.apiRlogModifyShipmentURL;
          env.apiRlogReturnsToteSlpLabelURL = res.apiRlogReturnsToteSlpLabelURL;
          env.apiRlogSwapSerialBlURL = res.apiRlogSwapSerialBlURL;
          env.apiRlogInquiryURL = res.apiRlogInquiryURL;
          env.apiRlogCpiConfigURL = res.apiRlogCpiConfigURL;
          env.apiRlogPrescanAsnsURL = res.apiRlogPrescanAsnsURL;
          env.apiRlogInvStatusChangeURL = res.apiRlogInvStatusChangeURL;
          env.uiFCLURL = res.uiFCLURL;
          env.apiUfixURL = res.apiUfixURL;
          env.fclUserInfoClientId = res.fclUserInfoClientId;
          env.fclUserInfoSecret = res.fclUserInfoSecret;
          env.apiReceivingUrl = res.apiReceivingUrl;
          env.apiContainerURL = res.apiContainerURL;
          env.apiSaveAuthJsonURL = res.apiSaveAuthJsonURL;
          env.apiInvoicingURL = res.apiInvoicingURL;
          env.apiInvoicingConfigURL = res.apiInvoicingConfigURL;
          env.apiPowerBiEmbedURL = res.apiPowerBiEmbedURL;  
          env.apiPowerBiPicklistEmbedURL = res.apiPowerBiPicklistEmbedURL;
          env.apiPhysicalInventoryURL = res.apiPhysicalInventoryURL;
          env.apiInvMovementURL = res.apiInvMovementURL;
          env.apiYardURL = res.apiYardURL;
          env.apiTriageURL = res.apiTriageURL;
          env.apiTriageInquiryURL = res.apiTriageInquiryURL;
          env.apiCartonHandler = res.apiCartonHandler;
          env.apiProcessURL = res.apiProcessURL;
          env.apiInboundQaURL = res.apiInboundQaURL;
          env.apiInboundQaAuditURL = res.apiInboundQaAuditURL;
          env.apiRepairURL = res.apiRepairURL;
          env.apiHouseKeepingURL = res.apiHouseKeepingURL;
          env.apiPackNewServiceUrl = res.apiPackNewServiceUrl;
          env.apiAQLMasterURL = res.apiAQLMasterURL;
          env.apiClearLocation = res.apiClearLocation;
          env.apiBlackList = res.apiBlackList;
          env.apiGroupConfig = res.apiGroupConfig;
          const oktaSettings = new OktaSettings();
          const oktaConfig = new OktaConfig();
  
          if (localStorage.getItem('userType') === 'I') {
            oktaConfig.clientId = env.oktaClientId;
            oktaConfig.issuer = env.oktaIssuer;
            oktaConfig.redirectUri = env.oktaURL + '/authorization-code/callback';
            oktaConfig.scopes = env.oktaScopes;
            oktaConfig.pkce = true;
            oktaSettings.oktaConfiguration = oktaConfig;
          } else {
            oktaConfig.clientId = env.oktaTempClientId;
            oktaConfig.issuer = env.oktaTempIssuer;
            oktaConfig.redirectUri = env.oktaURL + '/authorization-code/callback';
            oktaConfig.pkce = true;
            oktaSettings.oktaConfiguration = oktaConfig;
          }
  
          this.appSettingsService.setSettings(oktaSettings);
  
  
        },
        err => { console.error('error occurred: ', err); }
      );
    } else {

      const oktaSettings = new OktaSettings();
      const oktaConfig = new OktaConfig();
      
      if (localStorage.getItem('userType') === 'I') {
        oktaConfig.clientId = env.oktaClientId;
        oktaConfig.issuer = env.oktaIssuer;
        oktaConfig.redirectUri = env.oktaURL + '/authorization-code/callback';
        oktaConfig.scopes = env.oktaScopes;
        oktaConfig.pkce = true;
        oktaSettings.oktaConfiguration = oktaConfig;
      } else {
        oktaConfig.clientId = env.oktaTempClientId;
        oktaConfig.issuer = env.oktaTempIssuer;
        oktaConfig.redirectUri = env.oktaURL + '/authorization-code/callback';
        oktaConfig.pkce = true;
        oktaSettings.oktaConfiguration = oktaConfig;
      }

      this.appSettingsService.setSettings(oktaSettings);
    }
  }
}
